/*
 * op template engine
 *
 * Copyright (c) 2019 "optile GmbH" Joseph El Alam
 */

'use strict';

var escapeHtml = require('escape-html');

/**
 * Processes HTML template (from OPP) and replaces the placeholders with corresponding values
 * Placeholder pattern: ${ placeholder_name }
 *
 * @param {String} template the HTML template for account form
 * @param {Object} placeholders the map of placeholders to process HTML template (at least placeholder for "formId" is expected)
 * @param {String} defaultValue the value that will be used if placeholder cannot be resolved ("" by default)
 * @param {Boolean} isEscapeHtml if should escape html caracters
 *
 * @return {String} the result of HTML template processing
 */
function opTemplateEngine(template, placeholders, defaultValue, isEscapeHtml) {
    if (template) {
        // if not defined - empty map
        placeholders = placeholders || {};
        defaultValue = defaultValue ? escapeHtml(defaultValue) : '';

        // HTML templates from OPP support a placeholder pattern: ${ placeholder_name }
        return template.replace(/\${(.*?)}/g, function(match, text) {
            var value = placeholders[text];
            return value
                ? isEscapeHtml
                    ? escapeHtml(value)
                    : value
                : defaultValue;
        });
    } else {
        return template;
    }
}

module.exports = opTemplateEngine;
